import { render, staticRenderFns } from "./HeroComponent.vue?vue&type=template&id=f22c7772&scoped=true"
import script from "./HeroComponent.vue?vue&type=script&lang=js"
export * from "./HeroComponent.vue?vue&type=script&lang=js"
import style0 from "./HeroComponent.vue?vue&type=style&index=0&id=f22c7772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22c7772",
  null
  
)

export default component.exports